module.exports = __webpack_public_path__ + "static/media/HCMM258.71571bc5.jpg";